/**
 * Whether the user may see the dashboard's team cards (Who is off, Events). Mirrors the
 * server's gate (DASHBOARD_READ_TEAM in server/constants/permissions.js):
 * dashboard:read_team, or employees:read_all, which covers it.
 */
export const canSeeTeamCalendar = ({ hasPermission }) =>
  hasPermission('dashboard', 'read_team') || hasPermission('employees', 'read_all');
